import {
    FETCH_TASKS,
    FETCH_TASKS_SUCCESS,
    FETCH_TASKS_FAILED,
    ACCEPT_TASK,
    CANCEL_TASK,
    FETCH_ORDER_LIST_QUEUE,
    FETCH_ORDER_LIST_QUEUE_SUCCESS,
    FETCH_ORDER_LIST_QUEUE_FAILED,
} from "../store/types";

const INITIAL_STATE = {
    tasks: null,
    adminQueueOrders: null,
    loading: false,
    error: {
        flag: false,
        msg: null
    }
}

export const tasklistreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_TASKS:
            return {
                ...state,
                loading: true
            };
        case FETCH_TASKS_SUCCESS:
            return {
                ...state,
                tasks: action.payload,
                loading: false
            };
        case FETCH_TASKS_FAILED:
            return {
                ...state,
                tasks: null,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        case ACCEPT_TASK:
            return {
                ...state,
                 // Update the specific task status in adminQueueOrders if it exists
                 adminQueueOrders: state.adminQueueOrders ? 
                 state.adminQueueOrders.map(order => 
                     order.id === action.payload.task.id 
                         ? { ...order, status: 'ACCEPTED', driver: action.payload.task.driver }
                         : order
                 ) : state.adminQueueOrders
            }; 
        case CANCEL_TASK:
            return {
                ...state
            };
        case FETCH_ORDER_LIST_QUEUE:
            return {
                ...state,
                loading: true
            };
        case FETCH_ORDER_LIST_QUEUE_SUCCESS:
            return {
                ...state,
                adminQueueOrders: action.payload,
                loading: false
            };
        case FETCH_ORDER_LIST_QUEUE_FAILED:
            return {
                ...state,
                adminQueueOrders: null,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        default:
            return state;
    }
};